'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
require('prop-types');
var Grid = require('../../../DesignSystem/Layout/Grid/Grid.js');
var classNames = require('classnames');
var withStyles = require('../../../node_modules/@material-ui/core/esm/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var TOP_POSITION_ON_OVERLAY = -120;

var styles = function styles(theme) {
  return {
    leftPane: {},
    rightPane: defineProperty({
      position: "sticky",
      height: 1,
      zIndex: 2
    }, theme.breakpoints.up('md'), {
      width: 500
    }),
    regularPosition: {
      top: 120
    },
    overlayPosition: {
      top: "calc(65px + ".concat(-1 * TOP_POSITION_ON_OVERLAY, "px)")
    }
  };
};

var SplitPaneStickyRight = function SplitPaneStickyRight(_ref) {
  var classes = _ref.classes,
      leftPane = _ref.leftPane,
      rightPane = _ref.rightPane,
      rightPaneHasNegativePosition = _ref.rightPaneHasNegativePosition;
  return React__default["default"].createElement(Grid, {
    container: true,
    spacing: 40,
    justify: "center"
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: true,
    className: classes.leftPane
  }, leftPane), React__default["default"].createElement(Grid, {
    item: true,
    className: classNames__default["default"](classes.rightPane, rightPaneHasNegativePosition ? classes.overlayPosition : classes.regularPosition)
  }, rightPane));
};

SplitPaneStickyRight.defaultProps = {
  rightPaneHasNegativePosition: false
};
var SplitPaneStickyRight$1 = withStyles(styles)(SplitPaneStickyRight);

exports.TOP_POSITION_ON_OVERLAY = TOP_POSITION_ON_OVERLAY;
exports["default"] = SplitPaneStickyRight$1;
